module.exports = __webpack_public_path__ + "img/abstract-shapes-3.e342e55a.svg";